module.exports = __webpack_public_path__ + "img/icon9.6203ec84.svg";